import { FILTER_CATEGORIES_CONFIG } from '@resources/js/components/filters/filterCategoriesConfig';
import { isSameValues } from '@resources/js/components/filters/helpers';
const isCategoryAvailable = (category, filtersData) => { var _a; return Boolean((_a = filtersData[category]) === null || _a === void 0 ? void 0 : _a.length); };
const isCategoryActive = (category, state) => { var _a; return Boolean((_a = state[category]) === null || _a === void 0 ? void 0 : _a.length); };
// пресет не показуємо, коли:
// - якогось його значення немає у фільтрах міста
// - усі його значення вже обрані в сторі (тоді його стан показує чипс категорії)
const isPresetVisible = (preset, filtersData, state) => {
    var _a, _b;
    const categoryOptions = (_a = filtersData[preset.category]) !== null && _a !== void 0 ? _a : [];
    const selectedValues = (_b = state[preset.category]) !== null && _b !== void 0 ? _b : [];
    const isAvailable = preset.values.every(value => categoryOptions.some(option => option.id === value));
    const isApplied = preset.values.every(value => selectedValues.includes(value));
    return isAvailable && !isApplied;
};
const getCategoryChipLabel = (category, options) => {
    var _a, _b, _c, _d, _e;
    const { state, presets, filtersData, categoryLabels } = options;
    const selectedValues = (_a = state[category]) !== null && _a !== void 0 ? _a : [];
    if (!selectedValues.length)
        return (_b = categoryLabels[category]) !== null && _b !== void 0 ? _b : category;
    const matchedPreset = presets.find(preset => preset.category === category &&
        isSameValues(preset.values, selectedValues));
    if (matchedPreset)
        return matchedPreset.label;
    // назва останнього обраного значення з API; якщо не знайдено — сам id
    const lastValue = selectedValues[selectedValues.length - 1];
    const lastValueLabel = (_e = (_d = (_c = filtersData[category]) === null || _c === void 0 ? void 0 : _c.find(option => option.id === lastValue)) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : String(lastValue);
    const restCount = selectedValues.length - 1;
    return restCount ? `${lastValueLabel} +${restCount}` : lastValueLabel;
};
const createCategoryChip = (category, active, options) => ({
    type: 'category',
    key: category,
    category,
    label: getCategoryChipLabel(category, options),
    active,
});
const createPresetChip = ({ key, category, label, icon, }) => ({
    type: 'preset',
    key,
    category,
    label,
    icon,
    active: false,
});
export const buildQuickFilters = (options) => {
    const { state, presets, filtersData, activeOrder } = options;
    // 1. активні категорії — на початку, у порядку активації
    const activeChips = activeOrder
        .filter(category => isCategoryActive(category, state))
        .map(category => createCategoryChip(category, true, options));
    // 2. неактивні пресети — у порядку конфігу пресетів
    const presetChips = presets
        .filter(preset => isPresetVisible(preset, filtersData, state))
        .map(createPresetChip);
    // 3. неактивні категорії — у порядку FILTER_CATEGORIES_CONFIG
    const inactiveCategoryChips = Object.keys(FILTER_CATEGORIES_CONFIG)
        .filter(category => isCategoryAvailable(category, filtersData) &&
        !isCategoryActive(category, state))
        .map(category => createCategoryChip(category, false, options));
    return [...activeChips, ...presetChips, ...inactiveCategoryChips];
};
